export default "__VITE_ASSET__b4f189c5__"